import {Pipe, PipeTransform} from '@angular/core';

const intervals: { [key: string]: number } = {
    y: 31536000,
    m: 2592000,
    w: 604800,
    d: 86400,
    h: 3600,
    minute: 60,
    second: 1,
};

@Pipe({
    name: 'dateAgo',
    pure: true,
    standalone: true,
})
export class DateAgoPipe implements PipeTransform {
    transform(value: any, ...args: unknown[]): unknown {
        if (value) {
            const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
            if (seconds < 29) {
                // less than 30 seconds go is Just now
                return 'just now';
            }

            let counter;
            for (const i in intervals) {
                counter = Math.floor(seconds / intervals[i]);
                if (counter > 0) {
                    const unit = i.substring(0, 3);
                    return `${counter}${unit}`;
                }
            }
        }

        return value;
    }
}
